<template>
          <div class="card-footer">
                <div class="row">
                  <div class="col-sm-3 col-6">
                    <div class="description-block border-right pr-4">
                        <i class="fas fa-2x fa-assistive-listening-systems text-info d-block"></i>  
                      <h5 class="description-header mt-2">{{getStats.total || 0 }}</h5>
                      <small class="description-text">Total Listeners</small>
                       <span class="d-block description-percentage text-success">
                         <!-- <i class="fas fa-caret-up"></i> 100% -->
                        </span>
                    </div>
                    <!-- /.description-block -->
                  </div>
                  <!-- /.col -->
                  <div class="col-sm-3 col-6">
                    <div class="description-block app-border-right">
                        <i class="fas fa-2x fa-fingerprint d-block text-warning"></i>  
                      <h5 class="description-header mt-2">{{getStats.unique || 0}}</h5>
                      <small class="description-text">Unique Listeners</small>
                       <span class="d-block description-percentage text-danger">
                         <!-- <i class="fas fa-caret-up"></i> 3% -->
                        </span>
                    </div>
                    <!-- /.description-block -->
                  </div>
                  <!-- /.col -->
                  <div class="col-sm-3 col-6">
                    <div class="description-block border-right pr-4">
                        <i class="fas fa-2x fa-tachometer-alt d-block"></i>  
                      <h5 class="description-header mt-2">{{getStats.peak || 0}}</h5>
                      <small class="description-text">Peak Listeners</small>
                       <span class="d-block description-percentage text-warning">
                         <!-- <i class="fas fa-caret-up"></i> 17% -->
                        </span>
                    </div>
                    <!-- /.description-block -->
                  </div>
                  <!-- /.col -->
                  <div class="col-sm-3 col-6">
                    <div class="description-block">
                        <i class="fas fa-2x fa-clock d-block text-success"></i>  
                      <h5 class="description-header mt-2">{{getStats.avgTime ||'00:00:00'}}</h5>
                      <small class="description-text">Average Listening Time</small>
                       <span class="d-block description-percentage text-success">
                         <!-- <i class="fas fa-caret-up"></i> 85% -->
                        </span>
                    </div>
                    <!-- /.description-block -->
                  </div>
                  <!-- /.col -->
                 
                </div>
                <!-- /.row -->
              </div>
</template>

<script>

import { mapState } from "vuex";
export default {

  computed:{
    ...mapState({
    stats: state => state.dashboard.top_stats
  }),

  getStats(){

    return this.stats || 0

  }


  } 
  
}
</script>

<style scoped>
.card-footer {
    background-color: white;
}

@media only screen and (min-width : 992px) {
.app-border-right {
    border-right: 1px solid #dee2e6 !important;
}
}
</style>